import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class EmployeeOnboard extends DomainObject {
  id;
  currentStep;
  steps;
  accountCreated;
  complete;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      currentStep: observable,
      steps: observable,
      accountCreated: observable,
      complete: observable
    });

    this.merge(other);
  }

  isStepCompleted(step) {
    return step.order < this.currentStep.order;
  }

  isStepCurrent(step) {
    return step.id === this.currentStep.id;
  }
}

export default EmployeeOnboard;
